import { Popover, List, ListItemButton, ListItemText, ListItemIcon } from '@mui/material';

import { ICustomPopover } from './@types';

export const CustomPopover = ({ openPopover, anchorEl, handleClosePopover, list }: ICustomPopover) => (
  <Popover
    open={openPopover}
    anchorEl={anchorEl}
    onClose={handleClosePopover}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'left',
    }}
    elevation={1}
  >
    <List>
      {list.map(
        (item, index: number) =>
          !item.hidden && (
            <ListItemButton key={`${index}-${item?.label}`} onClick={item.onClick}>
              <ListItemIcon sx={{ minWidth: 40, color: 'primary.dark' }}>
                <item.icon />
              </ListItemIcon>
              <ListItemText primary={item.label} />
            </ListItemButton>
          )
      )}
    </List>
  </Popover>
);
